import { ProductAddonTypeTyKeys } from '@teinor/erp/types/company/config/parameter'

const useOrderProductAddonModal = () => {
    const orderProductAddonModal: Record<ProductAddonTypeTyKeys, { urlBuy?: string, fieldBuy?: string, urlSell?: string, fieldSell?: string}> = {
        0: { 
            urlBuy: '/api/app/product/productAddonBuy/getAllAddonProductsForBuyOrder',
            fieldBuy: 'ProductAddonBuy',
            urlSell: '/api/app/product/productAddon/getAllAddonProductsForOrder',
            fieldSell: 'ProductAddon',
        },
        1: { 
            urlSell: '/api/app/product/productAddon/getAllAddonProductsForOrder',
            fieldSell: 'ProductAddon',
        },
        2: { 
            urlBuy: '/api/app/product/productAddonBuy/getAllAddonProductsForBuyOrder',
            fieldBuy: 'ProductAddonBuy',
        },
        3: { 
            urlBuy: '/api/app/product/productAddon/getAllAddonProductsForOrder',
            fieldBuy: 'ProductAddon',
            urlSell: '/api/app/product/productAddon/getAllAddonProductsForOrder',
            fieldSell: 'ProductAddon',
        },
    }
    return orderProductAddonModal
}

export default useOrderProductAddonModal